<template>
  <b-modal ref="new-loop" hide-footer title="Nouvelle boucle">
    <div class="d-block text-center">
      <b-container fluid>
        <b-form @submit="onSubmit">
                    <b-form-group
                        id="loopName"
                        label="Nom"
                        label-for="loopInputName">
                        <b-form-input
                        id="loopInputName"
                        type="text"
                        v-model="loop_name"
                        required
                        placeholder="loop_supply_external"
                        />
                    </b-form-group>
                    <b-form-group
                        id="loopDescription"
                        label="Description"
                        label-for="loopDescription1">
                        <b-form-input
                        id="loopDescription1"
                        type="text"
                        v-model="loop_description"
                        required
                        placeholder="Boucle externe"
                        />
                    </b-form-group>
                    <b-button type="submit" variant="primary">Créer</b-button>
                </b-form>
        <b-row>
          <b-col sm="5">
            <b-button
              class="mt-3"
              variant="outline-danger"
              block
              @click="hideModal()"
            >
              Annuler
            </b-button>
          </b-col>
        </b-row>
      </b-container>
    </div>
  </b-modal>
</template>

<script>
import server from '../../api/server.vue'

export default {
  name: 'NewLoop',
  props: [],
  data() {
    return {
      loop_name: "",
      loop_description: ""
    }
  },
  computed: {
  },
  methods: {
    hideModal () {
      this.$refs['new-loop'].hide()
    },
    showModal () {
      this.$refs['new-loop'].show()
    },
     onSubmit(evt) {
        evt.preventDefault()
        server.addNewLoop({'name': this.loop_name ,'description': this.loop_description}).then(() => {
            this.makeToast("MaJ réussie !")
            this.hideModal()
            this.goTo('/loop/update/' + this.loop_name)
        })
      },
      onReset(evt) {
        evt.preventDefault()
        /* Reset our form values */
        this.resetValues()
        /* Trick to reset/clear native browser form validation state */
        this.show = false
        this.$nextTick(() => {
            this.show = true
        })
      },
      resetValues () {
          this.loop_name = ""
          this.loop_description = ""
      }
  },
  mounted: function() {
  },
  components: { }
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/loops/NewLoopModal.vue